<template>
    <div data-component="AmsListItemConsumptions">
        <span key="consumptions" class="text-dustygray text-caption">
            {{ textOrDefault(item.fuelConsumptionCombined) }} {{ unitFor(item.fuelType) }}
            <span class="pr-5">,</span>
        </span>
        <span key="emissions" class="text-dustygray text-caption">
            {{ textOrDefault(props.item.co2emissionInGramPerKm) }} g CO2/km (komb)*
        </span>
    </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { AmsItem, FuelType } from '../../services/amsSearch/amsSearch.interface'

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
})

const textOrDefault = (text?: string | number) => (text ? text.toString() : '-/-')

const unitFor = (fuelType: FuelType) => (fuelType === FuelType.Electro ? 'kWh/100km (komb)*' : 'l/100km (komb)*')
</script>
